'use strict';
import getUrls from './getUrls';
import getMainUrls from 'getUrls';

module.exports = {
  'home': getUrls.getHomeUrl(),
  'ses': getUrls.getSelfEvaluation(),
  'my-profile': getUrls.getProfileUrl(),
  'logout': getMainUrls.getLogoutUrl(),
};
